export default class SubNavigation {
	private parentSelectors: NodeListOf< HTMLElement >;
	private readonly documentClickCallback: EventListener;

	public constructor() {
		this.documentClickCallback = this.hideMenuList;
		this.parentSelectors = document.querySelectorAll( '.menu-item a[href="#"]' );
		this.parentSelectors?.forEach( ( element: HTMLElement ) => {
			element.addEventListener( 'click', ( event ) => this.toggleVisibility( event, element ) );
		} );
	}

	private toggleVisibility = ( event: MouseEvent, parentSelector: HTMLElement ): void => {
		event.preventDefault();
		event.stopPropagation();

		this.parentSelectors?.forEach( ( element: HTMLElement ) => {
			if ( element !== parentSelector ) {
				element.classList.remove( 'active' );
			}
		} );

		if ( parentSelector.classList.contains( 'active' ) ) {
			document.body.removeEventListener( 'click', this.documentClickCallback );
			parentSelector.classList.remove( 'active' );
		} else {
			document.body.addEventListener( 'click', this.documentClickCallback );
			parentSelector.classList.add( 'active' );
		}
	};

	private hideMenuList = ( event: Event ): void => {
		const target: Element = event.target as Element;

		if ( ! target.classList.contains( 'active' ) ) {
			document.body.removeEventListener( 'click', this.documentClickCallback );
			this.parentSelectors.forEach( ( element: HTMLElement ) => {
				element.classList.remove( 'active' );
			} );
		}
	};
}
